module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/b3bb6bf5e17cd307b3f50d76fe4b7d62.png";